export default __webpack_public_path__ + "static/media/aboutimage.b0c30851.png";